import React from "react";
import { AlertCircle } from "lucide-react";
import { motion } from "framer-motion";
import { Typography, Box } from "@mui/material";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline"; // Added this import

const ErrorDisplay = ({ error, entityId }) => {
  const getErrorContent = (errorCode) => {
    switch (errorCode) {
      case 5001:
        return {
          icon: (
            <ErrorOutlineIcon
              sx={{
                fontSize: 80,
                color: "error.main", // Using error color for 500
                mb: 1,
              }}
            />
          ),
          title: "שגיאת שרת",
          colorTitle: "error.main",
          message: `אירעה שגיאה בעת טעינת הנתונים. אנא נסה שוב מאוחר יותר`,
        };
      case 404:
        return {
          icon: (
            <SearchOffIcon
              sx={{
                fontSize: 80,
                color: "primary.light",
                mb: 1,
              }}
            />
          ),
          title: "לא נמצאו תוצאות",
          colorTitle: "primary.main",
          message:
            "לא נמצאו רשומות התואמות את החיפוש. אנא נסה שוב עם מזהים אחרים.",
        };
      default:
        return {
          icon: (
            <AlertCircle
              size={80} // Use size instead of fontSize
              color="#000000" // Direct color prop
              className="mb-1" // Use className for margin
            />
          ),
          title: "אירעה שגיאה",
          colorTitle: "#000000",
          message: "אירעה שגיאה לא צפויה. אנא נסה שוב",
        };
    }
  };

  const errorContent = getErrorContent(error?.status || 500);

  return (
    <Box
      component={motion.div}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: 4,
        m: 2,
        bgcolor: "background.paper",
      }}
    >
      <Box
        component={motion.div}
        animate={{
          scale: [1, 1.1, 1],
          rotate: [0, 10, -10, 0],
        }}
        transition={{ duration: 0.5 }}
      >
        {errorContent.icon}
      </Box>
      <Typography
        variant="h5"
        color={errorContent.colorTitle}
        gutterBottom
        sx={{ fontWeight: "medium" }}
      >
        {errorContent.title}
      </Typography>
      <Typography
        variant="body1"
        color={"text.secondary"}
        textAlign="center"
        sx={{ maxWidth: 400 }}
      >
        {errorContent.message}
      </Typography>
    </Box>
  );
};

export default ErrorDisplay;
